module.exports = __webpack_public_path__ + "img/32_24.98e3ac9c.png";